import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseGridResponse } from 'src/app/core/custom-grid/custom-grid';
import { DarkModeResponse } from 'src/app/model/global-interface';
import { GlobalService } from 'src/app/services/global.service';
import { environment } from 'src/environments/environment';
import { AppGlobalSettings, AppGlobalSettingsRequest, UserSettingsResponse } from './settings';
import { BaseResponse } from 'src/app/model/response/base-response';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private apiUrl: string = `${environment.apiUrl}/settings`;

  private baseHref: string = `${environment.baseHREF}`;
  constructor(private http: HttpClient) { }


  GetSettings(): Observable<AppGlobalSettings> {
    return this.http.get<AppGlobalSettings>(`${this.apiUrl}`);
  }

  UpdateSettings(request: AppGlobalSettingsRequest): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(`${this.apiUrl}/update`, request);
  }

  

}
